import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Productie/CalitateModels.cs ----------

export type QcCheckpoint = 'ControlProces' | 'ControlFinal'
export type QcDecision = 'Acceptat' | 'Respins' | 'Rework' | 'Carantina'
export type NonconformitySeverity = 'Minora' | 'Majora' | 'Critica'
export type StockStatus = 'Liber' | 'Blocat' | 'InControl' | 'Scrap'

export interface NonconformityType { id: string; code: string; description: string; isActive: boolean }
export interface SaveNonconformityTypePayload { code: string; description: string; isActive: boolean }

export interface CreateNonconformityPayload {
  nonconformityTypeId: string; cause: string | null; severity: NonconformitySeverity
  correctiveAction: string | null; responsibleUserId: string | null; dueDate: string | null
}

export interface QualityNonconformity {
  id: string; nonconformityTypeId: string; nonconformityTypeCode: string; nonconformityTypeDescription: string
  cause: string | null; severity: NonconformitySeverity; correctiveAction: string | null
  responsibleUserId: string | null; responsibleUserName: string | null; dueDate: string | null
  resolved: boolean; resolvedAt: string | null
}

export interface CreateInspectionPayload {
  checkpoint: QcCheckpoint; articleId: string; lotNumber: string | null; productionOrderId: string | null
  warehouseId: string; zoneId: string | null; locationId: string | null
  sampleWeightGrams: number | null; measuredDimensionMm: number | null; wallThicknessMm: number | null
  visualDefectsFound: boolean; decision: QcDecision; quantityThousands: number; notes: string | null
  nonconformities: CreateNonconformityPayload[]
}

export interface QualityInspectionListItem {
  id: string; checkpoint: QcCheckpoint; articleId: string; articleCode: string; articleDescription: string
  lotNumber: string | null; productionOrderId: string | null; productionOrderNumber: string | null
  decision: QcDecision; quantityThousands: number; inspectedAt: string; nonconformityCount: number
}

export interface QualityInspectionDetail {
  id: string; checkpoint: QcCheckpoint; articleId: string; articleCode: string; articleDescription: string
  lotNumber: string | null; productionOrderId: string | null; productionOrderNumber: string | null
  warehouseId: string; warehouseName: string; zoneId: string | null; zoneName: string | null
  locationId: string | null; locationCode: string | null
  sampleWeightGrams: number | null; measuredDimensionMm: number | null; wallThicknessMm: number | null
  visualDefectsFound: boolean; decision: QcDecision; quantityThousands: number; notes: string | null
  inspectedAt: string; inspectedByUserName: string; nonconformities: QualityNonconformity[]
}

export interface LotStockBalance { status: StockStatus; quantity: number }
export interface QualityCertificate {
  articleId: string; articleCode: string; articleDescription: string; lotNumber: string
  stockBalances: LotStockBalance[]; inspections: QualityInspectionDetail[]
}

export const listNonconformityTypes = () => api.get<NonconformityType[]>('/productie/calitate/neconformitati').then((r) => r.data)
export const createNonconformityType = (payload: SaveNonconformityTypePayload) =>
  api.post<NonconformityType>('/productie/calitate/neconformitati', payload).then((r) => r.data)
export const updateNonconformityType = (id: string, payload: SaveNonconformityTypePayload) =>
  api.put(`/productie/calitate/neconformitati/${id}`, payload)

export const listInspections = (params: { lotNumber?: string; productionOrderId?: string; checkpoint?: QcCheckpoint } = {}) =>
  api.get<QualityInspectionListItem[]>('/productie/calitate/inspectii', { params }).then((r) => r.data)
export const getInspection = (id: string) => api.get<QualityInspectionDetail>(`/productie/calitate/inspectii/${id}`).then((r) => r.data)
export const createInspection = (payload: CreateInspectionPayload) =>
  api.post<{ id: string }>('/productie/calitate/inspectii', payload).then((r) => r.data)
export const resolveNonconformity = (inspectionId: string, ncId: string) =>
  api.post(`/productie/calitate/inspectii/${inspectionId}/neconformitati/${ncId}/rezolva`)

export const getCertificate = (articleId: string, lotNumber: string) =>
  api.get<QualityCertificate>(`/productie/calitate/certificat/${articleId}/${encodeURIComponent(lotNumber)}`).then((r) => r.data)
